import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { OperatorContextService } from '../services/operator-context.service';
import { OperatorService } from '../services/operator.service';
import { catchError, map, of } from 'rxjs';

export const operatorGuardFn: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const router = inject(Router);
  const operatorContextService = inject(OperatorContextService);
  const operatorService = inject(OperatorService);
  const schoolId = route.paramMap.get('schoolId');

  if (!schoolId) {
    console.error('No schoolId found in route');
    router.navigate(['/not-found']);
    return false;
  }

  // No need to parse to int, just validate that it's a valid GUID
  const isValidGuid =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      schoolId,
    );

  if (!isValidGuid) {
    console.error('Invalid GUID format');
    router.navigate(['/not-found']);
    return false;
  }

  // Check if we already have the operator data
  const currentOperator = operatorContextService.getCurrentOperatorValue();

  if (
    currentOperator &&
    (currentOperator.operatorGuid === schoolId ||
      currentOperator.operatorId === schoolId)
  ) {
    return true;
  }

  // Fetch the operator data and set it in the context
  return operatorService.getOperator(schoolId).pipe(
    map((operator) => {
      // Set the current operator context
      operatorContextService.setCurrentOperator(operator);
      return true;
    }),
    catchError((error) => {
      console.error('Error fetching operator:', error);
      router.navigate(['/not-found']);
      return of(false);
    }),
  );
};
